var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01935 2.47655C4.64592 3.20432 3.3085 5.72462 4.03627 8.09805L4.67168 10.1703C4.8058 10.6077 4.82385 11.3317 4.7159 11.7728L4.31124 13.3952C4.06158 14.3974 4.70096 15.229 5.72986 15.2587C9.13695 15.3436 12.4712 14.3212 15.2451 12.341C16.0248 11.7882 16.0904 10.6463 15.3753 10.0026L14.1307 8.8859C13.8013 8.57899 13.4104 7.9693 13.2763 7.5319L12.6408 5.45963C11.9153 3.09337 9.3856 1.75099 7.01935 2.47655Z",
    stroke: "#5954DE",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40667 2.27747C8.1646 2.28109 7.91976 2.30126 7.67433 2.34513C6.95958 2.47016 6.31529 2.72263 5.7536 3.09098C5.79884 2.4966 6.20078 1.96543 6.8031 1.78074C7.40542 1.59605 8.03603 1.81061 8.40667 2.27747Z",
    stroke: "#5954DE",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7164 13.3978C13.0791 14.581 12.4079 15.8458 11.2248 16.2086C10.6368 16.3889 10.0171 16.3122 9.51118 16.0437C9.00525 15.7752 8.59435 15.305 8.41406 14.717",
    stroke: "#5954DE",
    strokeWidth: 1.125,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5b3bf6c5dfc27eb6cbf064bafbf150e0.svg";
export { ForwardRef as ReactComponent };